// Central catalog of the Atelier Door Collection by ViewLux
// Extracted from the official PDF specifications.

export const CATEGORIES = ["Exterior", "Interior", "Garage"];

// Exterior door sizing (per client spec)
export const EXTERIOR_MAX_HEIGHT = 120; // inches
export const EXTERIOR_MAX_WIDTH = 70; // inches
export const EXTERIOR_MIN_HEIGHT = 60;
export const EXTERIOR_MIN_WIDTH = 24;

// Garage door sizing (residential range: single up to oversized double)
export const GARAGE_MIN_HEIGHT = 72;
export const GARAGE_MAX_HEIGHT = 168;
export const GARAGE_MIN_WIDTH = 84;
export const GARAGE_MAX_WIDTH = 240;

// Quote gating: manufacturer minimum order across the whole cart
export const MIN_QUOTE_QUANTITY = 1;

// Interior door sizing presets (per client spec)
export const INTERIOR_HEIGHTS = ['80"', '84"', '96"', '108"'];
export const INTERIOR_WIDTHS = ['18"', '24"', '26"', '28"', '30"', '32"', '34"', '36"'];

export const EXTERIOR_SERIES = [
  {
    id: "toscana",
    name: "Toscana",
    tagline: "Veneer Finish",
    subtitle: "Natural wood veneer · Pivot Door",
    description:
      "Timeless elegance through carefully selected natural wood veneers. Rich grain, contemporary silhouettes, and a Digital Smart Lock.",
    image: "/exterior/correct-p23_i01.jpg",
    heroImage: "/exterior/correct-p23_i01.jpg",
    doorType: "Pivot Door",
    material: "Natural Wood Veneer",
    finish: "Natural Oak",
    handle: "Integrated Pull Handle",
    lock: "Digital Smart Lock",
    styles: [
      "01 Chevron Wood",
      "02 Minimal Oak",
      "03 Vertical Walnut",
      "04 Horizontal with Glass",
      "05 Fluted Modern",
      "06 Dark Horizontal",
    ],
  },
  {
    id: "monaco",
    name: "Monaco",
    tagline: "Aluminum Clad Finish",
    subtitle: "Aluminum-clad wood · Pivot Door",
    description:
      "Contemporary European engineering. Wood core, aluminum-clad exterior, exceptional weather resistance for luxury residences.",
    image: "/exterior/correct-p23_i02.jpg",
    heroImage: "/exterior/correct-p23_i02.jpg",
    doorType: "Pivot Door",
    material: "Aluminum Clad",
    finish: "Dark Walnut",
    handle: "Integrated Pull Handle",
    lock: "Digital Smart Lock",
    styles: [
      "01 Wooden Cube Designs",
      "02 Double Swing Vertical Oak",
      "03 Matte Black Geometric Diamond",
      "04 Dark Walnut Glass Inlay",
      "05 Horizontal Groove Panel Light Oak",
      "06 Geometric Diamond with Side Lights",
    ],
  },
  {
    id: "milano",
    name: "Milano",
    tagline: "Melamine Finish",
    subtitle: "Solid Wood · Entry Swing Door",
    description:
      "Contemporary Italian design meets durable melamine. Sleek aesthetics, refined proportions, single-cylinder security.",
    image: "/exterior/correct-p23_i00.jpg",
    heroImage: "/exterior/correct-p23_i00.jpg",
    doorType: "Entry Swing Door",
    material: "Solid Wood",
    finish: "Melamine",
    handle: "Square Lever",
    lock: "Single Cylinder",
    styles: [
      "01 Linear Oak with Black Accents",
      "02 Horizontal Walnut with Black Insert",
      "03 Sculpted Dark Oak with Recessed Detail",
      "04 Modern Oak with Vertical Glass",
      "05 Clean White Oak with Black Handle",
      "06 Natural Walnut with Metal Handle",
    ],
  },
];

export const INTERIOR_SERIES = [
  {
    id: "forma",
    name: "Forma",
    tagline: "Melamine Finish",
    subtitle: "Linear Grooved · Wood Slab",
    description:
      "A refined selection of interior doors with a premium melamine finish. Modern design meets everyday durability.",
    image: "/pdf-images/page-05.jpg",
    heroImage: "/pdf-embed/p05_i00.jpg",
    imageFit: "contain",
    doorType: "Swing Door",
    material: "Wood Slab",
    finish: "Melamine",
    handle: "Premium Lever Handle",
    maxHeight: '120"',
    maxWidth: '40"',
  },
  {
    id: "porto",
    name: "Porto",
    tagline: "Veneer Finish",
    subtitle: "Linear Fluted · Natural Wood Veneer",
    description:
      "The natural beauty of real wood through premium veneer finishes. Rich grain, organic character, timeless appeal.",
    image: "/pdf-images/page-06.jpg",
    heroImage: "/pdf-embed/p07_i00.jpg",
    doorType: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    handle: "Premium Pull Handle",
    maxHeight: '120"',
    maxWidth: '160"',
  },
  {
    id: "siena",
    name: "Siena",
    tagline: "Paint Finish",
    subtitle: "Flush · MDF · Concealed Hinges",
    description:
      "High-quality painted doors with a smooth, flawless finish. Clean lines, contemporary appeal, sophisticated presence.",
    image: "/pdf-images/page-08.jpg",
    heroImage: "/pdf-embed/p08_i00.jpg",
    doorType: "Swing Door",
    material: "MDF",
    finish: "High-Quality Paint",
    handle: "Premium Lever Handle",
    maxHeight: '108"',
    maxWidth: '38"',
  },
];

export const PANEL_STYLES = [
  { name: "Horizontal Inlay", image: "/pdf-embed/panel-horizontal-inlay.png" },
  { name: "Vertical Inlay", image: "/pdf-embed/panel-vertical-inlay.png" },
  { name: "Dual Horizontal", image: "/pdf-embed/panel-dual-horizontal.png" },
  { name: "Wide Vertical", image: "/pdf-embed/panel-wide-vertical.png" },
  { name: "Low Horizontal", image: "/pdf-embed/panel-low-horizontal.png" },
  { name: "Thin Vertical", image: "/pdf-embed/panel-thin-vertical.png" },
  { name: "Center Vertical", image: "/pdf-embed/panel-center-vertical.png" },
  { name: "Dual Vertical", image: "/pdf-embed/panel-dual-vertical.png" },
];

export const GLASS_INLAY_STYLES = [
  { name: "Chevron", image: "/pdf-embed/glassinlay-chevron.png" },
  { name: "Slot Lite", image: "/pdf-embed/glassinlay-slot-lite.png" },
  { name: "Full Lite", image: "/pdf-embed/glassinlay-full-lite.png" },
  { name: "Horizontal Lite", image: "/pdf-embed/glassinlay-horizontal-lite.png" },
  { name: "Vertical Lite", image: "/pdf-embed/glassinlay-vertical-lite.png" },
  { name: "Diamond Lite", image: "/pdf-embed/glassinlay-diamond-lite.png" },
  { name: "Grid Lite", image: "/pdf-embed/glassinlay-grid-lite.png" },
  { name: "Mixed Lite", image: "/pdf-embed/glassinlay-mixed-lite.png" },
];

const BERLIN_DESCRIPTION = "The Berlin overhead door is designed to make a statement. Its bold vertical ribbed design and integrated lighting create a striking architectural look with smooth, reliable overhead sectional operation.";

export const GARAGE_SERIES = [
  { id: "denver", name: "Denver", tagline: "Modern · Cohesive · Built To Last", image: "/pdf-embed/garage-denver.jpg", palette: ["Sand Black","Deep Grey","Warm Walnut","Dark Walnut","Chocolate Brown","Aged Teak","Driftwood Greige","Natural Oak"] },
  { id: "rio", name: "Rio De Janeiro", tagline: "Modern · Warm · Uncompromising", image: "/pdf-embed/garage-rio.jpg", palette: ["Sand Black","Deep Grey","Warm Walnut","Dark Walnut","Chocolate Brown","Aged Teak","Driftwood Greige","Natural Oak"] },
  { id: "denmark", name: "Denmark", tagline: "Modern · Timeless · Refined", image: "/pdf-embed/garage-denmark.jpg", palette: ["Sand Black","Deep Grey","Warm Walnut","Dark Walnut","Chocolate Brown","Aged Teak","Driftwood Greige","Natural Oak"] },
  { id: "montreal", name: "Montreal", tagline: "Sleek · Minimal · Sophisticated", image: "/pdf-embed/garage-montreal.jpg", palette: ["Sand Black","Deep Grey","Charcoal","Matte Bronze"] },
  { id: "wonderwall", name: "Wonderwall", tagline: "Bold Design · Smooth Performance", image: "/pdf-embed/garage-wonderwall.jpg", palette: ["Sand Black","Deep Grey","Charcoal","Dark Walnut","Walnut","Teak","Matte Bronze"] },
  { id: "berlin", name: "Berlin", tagline: "Sectional Overhead Door", description: BERLIN_DESCRIPTION, image: "/pdf-embed/garage-berlin.jpg", palette: ["Sand Black","Deep Grey","Charcoal","Dark Walnut","Walnut","Teak","Matte Bronze"] },
  { id: "monolight", name: "Monolight", tagline: "Minimalist · Modern · Unified", image: "/pdf-embed/garage-monolight.jpg", palette: ["Modern Gray","Charcoal","Dark Bronze","Black","White"] },
  { id: "dark-knight", name: "Dark Knight", tagline: "Reflective · Modern · Timeless", image: "/pdf-embed/garage-dark-knight.jpg", palette: ["Jet Black","Dark Grey","Bronze Tint","Smoke Grey"] },
  { id: "aspen", name: "Aspen", tagline: "Carriage Style · Warm Wood Tones", image: "/pdf-embed/garage-aspen-mountain.jpg", imageFit: "contain", palette: ["Chocolate Brown","Dark Oak","Modern Gray","Charcoal","Black","White","Warm Walnut","Dark Walnut","Driftwood Greige","Natural Oak"] },
  { id: "michigan", name: "Michigan", tagline: "Timeless Simplicity · Modern Appeal", image: "/pdf-embed/garage-michigan.jpg", palette: ["Aged Teak","Dark Walnut","Modern Gray","Charcoal","Black","White","Sand Black","Deep Grey","Chocolate Brown"] },
];

export const FINISHES = {
  "Wood Veneer": [
    { name: "Natural Oak", hex: "#C69A6A", image: "/pdf-embed/swatch-natural-oak.png" },
    { name: "White Oak", hex: "#D6BB94", image: "/pdf-embed/swatch-white-oak.png" },
    { name: "Walnut", hex: "#5B3A25", image: "/pdf-embed/swatch-walnut.png" },
    { name: "Ash", hex: "#C9B69A", image: "/pdf-embed/swatch-ash.png" },
    { name: "Rift Cut Oak", hex: "#B58C5C", image: "/pdf-embed/swatch-rift-cut-oak.png" },
    { name: "European Oak", hex: "#C08A55", image: "/pdf-embed/swatch-european-oak.png" },
    { name: "Mocha Oak", hex: "#6E4A32", image: "/pdf-embed/swatch-mocha-oak.png" },
    { name: "Smoked Oak", hex: "#3D2A20", image: "/pdf-embed/swatch-smoked-oak.png" },
  ],
  "Melamine": [
    { name: "Nordic Maple", hex: "#E6D9C1", image: "/pdf-embed/swatch-nordic-maple.png" },
    { name: "Sand Oak", hex: "#D4B98F", image: "/pdf-embed/swatch-sand-oak.png" },
    { name: "Dove Gray", hex: "#BEBAB4", image: "/pdf-embed/swatch-dove-gray.png" },
    { name: "Stone Gray", hex: "#8E8B85", image: "/pdf-embed/swatch-stone-gray.png" },
    { name: "Charcoal", hex: "#4A4744", image: "/pdf-embed/swatch-charcoal.png" },
    { name: "Graphite", hex: "#2C2A28", image: "/pdf-embed/swatch-graphite.png" },
    { name: "Jet Black", hex: "#0A0A0A", image: "/pdf-embed/swatch-jet-black.png" },
    { name: "Soft White", hex: "#F4EEE6", image: "/pdf-embed/swatch-soft-white.png" },
  ],
  "High-Quality Paint": [
    { name: "Pure White", hex: "#F7F4EE", image: "/pdf-embed/swatch-pure-white.png" },
    { name: "Warm White", hex: "#EFE7D8", image: "/pdf-embed/swatch-warm-white.png" },
    { name: "Light Gray", hex: "#C7C4BE", image: "/pdf-embed/swatch-light-gray.png" },
    { name: "Beige", hex: "#B4A793", image: "/pdf-embed/swatch-greige.png" },
    { name: "Taupe", hex: "#9E8B78", image: "/pdf-embed/swatch-taupe.png" },
    { name: "Deep Navy", hex: "#1E2C3F", image: "/pdf-embed/swatch-deep-navy.png" },
    { name: "Forest Green", hex: "#243B2F", image: "/pdf-embed/swatch-forest-green.png" },
    { name: "Matte Black", hex: "#0A0A0A", image: "/pdf-embed/swatch-matte-black.png" },
  ],
};

export const GARAGE_SWATCH_HEX = {
  "Sand Black": "#1A1918",
  "Deep Grey": "#3B3A38",
  "Warm Walnut": "#7A4A2C",
  "Dark Walnut": "#4A2E1E",
  "Chocolate Brown": "#43261A",
  "Aged Teak": "#5E4A2F",
  "Driftwood Greige": "#8E8272",
  "Natural Oak": "#C69A6A",
  "Charcoal": "#39373A",
  "Matte Bronze": "#5E4A34",
  "Walnut": "#5B3A25",
  "Teak": "#8B5A2B",
  "Dark Bronze": "#3A2A1E",
  "Modern Gray": "#8E8B87",
  "Black": "#0A0A0A",
  "White": "#F4EEE6",
  "Jet Black": "#050505",
  "Dark Grey": "#2C2C2C",
  "Bronze Tint": "#7A5A3A",
  "Smoke Grey": "#6E6E6E",
  "Dark Oak": "#4A311E",
};

export const HANDLE_COLLECTIONS = [
  { name: "Madrid", finish: "Oil Rubbed Bronze", image: "/pdf-embed/handle-madrid-rectangular-20261013.png" },
  { name: "Rome", finish: "Polished Chrome", image: "/pdf-embed/handle-rome.png" },
  { name: "Barcelona", finish: "Matte Black", image: "/pdf-embed/handle-barcelona.png" },
  { name: "Milan", finish: "Gold", image: "/pdf-embed/handle-milan-gold-20261013.png" },
  { name: "Florence", finish: "Satin Nickel", image: "/pdf-embed/handle-florence.png" },
  { name: "Naples", finish: "Bronze", image: "/pdf-embed/handle-naples.png" },
  { name: "Valencia", finish: "Real Wood", image: "/pdf-embed/handle-valencia.png" },
  { name: "Turin", finish: "Matte Black", image: "/pdf-embed/handle-turin.png" },
];

export const HARDWARE_FINISHES = [
  { name: "Gold", hex: "#d9bd8a", image: "/pdf-embed/hardware-finish-gold-20261013.png" },
  { name: "Silver", hex: "#c1c1c1", image: "/pdf-embed/hardware-finish-silver-20261013.png" },
  { name: "Black", hex: "#3f3f3f", image: "/pdf-embed/hardware-finish-black-20261013.png" },
  { name: "Matt Black", hex: "#313131", image: "/pdf-embed/hardware-finish-matt-black-20261013.png" },
  { name: "Bronze", hex: "#b79874", image: "/pdf-embed/hardware-finish-bronze-20261013.png" },
];

export const GLASS_OPTIONS = [
  { name: "None", image: null },
  { name: "Clear", image: "/pdf-embed/glass-clear.png" },
  { name: "Reeded", image: "/pdf-embed/glass-reeded.png" },
  { name: "Obscure", image: "/pdf-embed/glass-obscure.png" },
  { name: "Frosted", image: "/pdf-embed/glass-frosted.png" },
  { name: "Smoke", image: "/pdf-embed/glass-smoke.png" },
  { name: "Bronze", image: "/pdf-embed/glass-bronze.png" },
  { name: "Black", image: "/pdf-embed/glass-black.png" },
];

export const PROJECT_TYPES = ["Homeowner","Architect / Designer","Builder / Contractor","Commercial"];


// -----------------------------------------------------------------------------
// EXTERIOR DOOR MODELS
// Every model comes pre-configured with the exact finish, color, and hardware
// baked into the catalog on pages 24 (Toscana), 25 (Monaco), 26 (Milano).
// Customers only pick SIZE (height ≤ 120" × width ≤ 70") and quantity.
// -----------------------------------------------------------------------------
export const EXTERIOR_MODELS = [
  // ── Toscana (pg. 24) — Veneer Finish · Pivot Door ─────────────────────────
  {
    id: "toscana-01", series: "Toscana", model_no: "01",
    name: "Chevron Wood",
    image: "/pdf-embed/atelier-toscana-01-chevron-wood.jpg",
    description: "Hand-laid chevron pattern in natural oak veneer.",
    finish: "Natural Oak Veneer",
    color: "Natural Oak",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "toscana-02", series: "Toscana", model_no: "02",
    name: "Minimal Oak",
    image: "/pdf-embed/atelier-toscana-02-minimal-oak.jpg",
    description: "Clean vertical oak grain with long matte-black pull.",
    finish: "Oak Veneer",
    color: "Warm Oak",
    hardware: "Full-length Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "toscana-03", series: "Toscana", model_no: "03",
    name: "Vertical Walnut",
    image: "/pdf-embed/atelier-toscana-03-vertical-walnut.jpg",
    description: "Solid walnut veneer with continuous vertical figuring.",
    finish: "Walnut Veneer",
    color: "Dark Walnut",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "toscana-04", series: "Toscana", model_no: "04",
    name: "Horizontal with Glass",
    image: "/pdf-embed/atelier-toscana-04-horizontal-glass.jpg",
    description: "Horizontal oak plank with a slim vertical glass reveal.",
    finish: "Oak Veneer + Glass Insert",
    color: "Warm Oak · Reeded Glass",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "toscana-05", series: "Toscana", model_no: "05",
    name: "Fluted Modern",
    image: "/pdf-embed/atelier-toscana-05-fluted-modern.jpg",
    description: "Continuous vertical fluting with matte-black surround.",
    finish: "Fluted Oak Veneer",
    color: "Light Oak · Black Frame",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "toscana-06", series: "Toscana", model_no: "06",
    name: "Dark Horizontal",
    image: "/pdf-embed/atelier-toscana-06-dark-horizontal.jpg",
    description: "Dark-oak veneer with wide horizontal panels.",
    finish: "Oak Veneer",
    color: "Smoked Oak",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },

  // ── Monaco (pg. 25) — Aluminum-Clad · Pivot Door ──────────────────────────
  {
    id: "monaco-01", series: "Monaco", model_no: "01",
    name: "Wooden Cube",
    image: "/pdf-embed/atelier-monaco-01-wooden-cube.jpg",
    description: "Aluminum-clad walnut in a bold geometric cube layout.",
    finish: "Aluminum-Clad Walnut",
    color: "Walnut · Black Frame",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "monaco-02", series: "Monaco", model_no: "02",
    name: "Double Swing Vertical Oak",
    image: "/pdf-embed/atelier-monaco-02-double-swing-vertical-oak.jpg",
    description: "Twin pivot leaves with a light-oak center band.",
    finish: "Aluminum-Clad Oak",
    color: "Light Oak · Black Frame",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door (Double)",
  },
  {
    id: "monaco-03", series: "Monaco", model_no: "03",
    name: "Matte Black Diamond",
    image: "/pdf-embed/atelier-monaco-03-matte-black-diamond.jpg",
    description: "Matte-black door with etched diamond lines.",
    finish: "Powder-Coated Aluminum",
    color: "Matte Black",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "monaco-04", series: "Monaco", model_no: "04",
    name: "Dark Walnut Glass Inlay",
    image: "/pdf-embed/atelier-monaco-04-dark-walnut-glass-inlay.jpg",
    description: "Dark-walnut pivot with a slim vertical glass inlay.",
    finish: "Aluminum-Clad Walnut + Glass",
    color: "Dark Walnut · Bronze Glass",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "monaco-05", series: "Monaco", model_no: "05",
    name: "Horizontal Groove Light Oak",
    image: "/pdf-embed/atelier-monaco-05-horizontal-groove-light-oak.jpg",
    description: "Light-oak pivot with sculpted horizontal grooves.",
    finish: "Aluminum-Clad Oak",
    color: "Light Oak · Black Frame",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door",
  },
  {
    id: "monaco-06", series: "Monaco", model_no: "06",
    name: "Diamond with Side Lights",
    image: "/pdf-embed/atelier-monaco-06-geometric-diamond-side-lights.jpg",
    description: "Black geometric diamond with full-height side lights.",
    finish: "Powder-Coated Aluminum + Glass",
    color: "Matte Black · Clear Glass",
    hardware: "Integrated Pull · Digital Smart Lock",
    door_type: "Pivot Door + Side Lights",
  },

  // ── Milano (pg. 26) — Melamine · Pivot Door ───────────────────────────────
  {
    id: "milano-01", series: "Milano", model_no: "01",
    name: "Linear Oak with Black Accents",
    image: "/pdf-embed/atelier-milano-01-linear-oak-black-accents.jpg",
    description: "Light oak with vertical black inlay stripes.",
    finish: "Melamine Oak + Black Insert",
    color: "Light Oak · Black Accents",
    hardware: "Square Lever · Single-Cylinder Lock",
    door_type: "Pivot Door",
  },
  {
    id: "milano-02", series: "Milano", model_no: "02",
    name: "Horizontal Walnut with Black Insert",
    image: "/pdf-embed/atelier-milano-02-horizontal-walnut-black-insert.jpg",
    description: "Warm walnut with a matte-black horizontal insert.",
    finish: "Melamine Walnut + Black Insert",
    color: "Walnut · Matte Black",
    hardware: "Square Lever · Single-Cylinder Lock",
    door_type: "Pivot Door",
  },
  {
    id: "milano-03", series: "Milano", model_no: "03",
    name: "Sculpted Dark Oak",
    image: "/pdf-embed/atelier-milano-03-sculpted-dark-oak.jpg",
    description: "Dark oak with a subtle recessed sculpted detail.",
    finish: "Melamine Oak",
    color: "Smoked Oak",
    hardware: "Square Lever · Single-Cylinder Lock",
    door_type: "Pivot Door",
  },
  {
    id: "milano-04", series: "Milano", model_no: "04",
    name: "Modern Oak with Vertical Glass",
    image: "/pdf-embed/atelier-milano-04-modern-oak-vertical-glass.jpg",
    description: "Light oak plank with a vertical glass reveal.",
    finish: "Melamine Oak + Glass Insert",
    color: "Light Oak · Reeded Glass",
    hardware: "Square Lever · Single-Cylinder Lock",
    door_type: "Pivot Door",
  },
  {
    id: "milano-05", series: "Milano", model_no: "05",
    name: "Clean White Oak",
    image: "/pdf-embed/atelier-milano-05-clean-white-oak.jpg",
    description: "Whitewashed oak with slim black handle.",
    finish: "Melamine Oak",
    color: "White Oak",
    hardware: "Square Lever · Single-Cylinder Lock",
    door_type: "Pivot Door",
  },
  {
    id: "milano-06", series: "Milano", model_no: "06",
    name: "Natural Walnut with Metal Handle",
    image: "/pdf-embed/atelier-milano-06-natural-walnut-metal-handle.jpg",
    description: "Deep walnut with polished metal pull.",
    finish: "Melamine Walnut",
    color: "Natural Walnut · Brushed Metal",
    hardware: "Long Pull · Single-Cylinder Lock",
    door_type: "Pivot Door",
  },
];

export const EXTERIOR_SERIES_ORDER = ["Toscana", "Monaco", "Milano"];


// -----------------------------------------------------------------------------
// INTERIOR DOOR MODELS
// Every interior model uses standard "sticker sizes" (INTERIOR_HEIGHTS &
// INTERIOR_WIDTHS above). Hardware is fixed per series. Colors & finishes are
// finalized with the atelier team after the estimate is prepared.
// -----------------------------------------------------------------------------
export const INTERIOR_MODELS = [
  // ── Forma (pg. 6) — Wood Slab · Melamine · Lever Handle ────────────────────
  {
    id: "forma-01", series: "Forma", model_no: "01",
    name: "Modern Linear",
    image: "/pdf-embed/forma-01-hd.jpg",
    description: "Signature linear-grooved oak slab with matte-black lever.",
    door_type: "Swing Door",
    material: "Wood Slab",
    finish: "Melamine",
    hardware: "Premium Lever Handle",
  },
  {
    id: "forma-02", series: "Forma", model_no: "02",
    name: "Warm Oak Sliding",
    image: "/pdf-embed/forma-02-hd.jpg",
    description: "Warm oak slab on a concealed sliding rail.",
    door_type: "Sliding Door",
    slide_only: true,
    material: "Wood Slab",
    finish: "Melamine",
    hardware: "Premium Pull Handle",
  },
  {
    id: "forma-03", series: "Forma", model_no: "03",
    name: "Warm Oak Panel",
    image: "/pdf-embed/forma-03-hd.jpg",
    description: "Warm-oak slab with a clean recessed panel.",
    door_type: "Swing Door",
    material: "Wood Slab",
    finish: "Melamine",
    hardware: "Premium Lever Handle",
  },
  {
    id: "forma-04", series: "Forma", model_no: "04",
    name: "Warm Oak Two-Panel",
    image: "/pdf-embed/forma-04-hd.jpg",
    description: "Warm-oak swing door with arched top and two recessed panels.",
    door_type: "Swing Door",
    swing_only: true,
    material: "Wood Slab",
    finish: "Melamine",
    hardware: "Premium Lever Handle",
  },
  {
    id: "forma-05", series: "Forma", model_no: "05",
    name: "Vertical Oak",
    image: "/pdf-embed/forma-05-hd.jpg",
    description: "Light-oak slab with continuous vertical grain.",
    door_type: "Swing Door",
    material: "Wood Slab",
    finish: "Melamine",
    hardware: "Premium Lever Handle",
  },
  {
    id: "forma-06", series: "Forma", model_no: "06",
    name: "Linear Oak Sliding",
    image: "/pdf-embed/forma-06-hd.jpg",
    description: "Warm-oak sliding door with linear grooved pattern.",
    door_type: "Sliding Door",
    slide_only: true,
    material: "Wood Slab",
    finish: "Melamine",
    hardware: "Premium Pull Handle",
  },

  // ── Porto (pg. 7) — Sliding Door · Natural Wood Veneer · Premium Pull ─────
  {
    id: "porto-01", series: "Porto", model_no: "01",
    name: "Linear Fluted Veneer",
    image: "/pdf-embed/porto-01-hd.jpg",
    description: "Signature linear-fluted natural wood veneer sliding leaf.",
    door_type: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    hardware: "Premium Pull Handle",
  },
  {
    id: "porto-02", series: "Porto", model_no: "02",
    name: "Ribbed Walnut",
    image: "/pdf-embed/porto-02-hd.jpg",
    description: "Ribbed walnut veneer with slim vertical grooves.",
    door_type: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    hardware: "Premium Pull Handle",
  },
  {
    id: "porto-03", series: "Porto", model_no: "03",
    name: "Warm Oak Panel",
    image: "/pdf-embed/porto-03-hd.jpg",
    description: "Warm-oak veneer with a horizontal reveal.",
    door_type: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    hardware: "Premium Pull Handle",
  },
  {
    id: "porto-04", series: "Porto", model_no: "04",
    name: "Chevron Oak",
    image: "/pdf-embed/porto-04-hd.jpg",
    description: "Chevron-cut oak veneer sliding leaf.",
    door_type: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    hardware: "Premium Pull Handle",
  },
  {
    id: "porto-05", series: "Porto", model_no: "05",
    name: "Smoked Oak Slab",
    image: "/pdf-embed/porto-05-hd.jpg",
    description: "Smoked-oak veneer with clean edge banding.",
    door_type: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    hardware: "Premium Pull Handle",
  },
  {
    id: "porto-06", series: "Porto", model_no: "06",
    name: "Bleached Oak",
    image: "/pdf-embed/porto-06-hd.jpg",
    description: "Bleached-oak veneer sliding leaf.",
    door_type: "Sliding Door",
    material: "Natural Wood Veneer",
    finish: "Veneer",
    hardware: "Premium Pull Handle",
  },

  // ── Siena (pg. 8) — Swing Door · MDF · High-Quality Paint · Lever Handle ──
  {
    id: "siena-01", series: "Siena", model_no: "01",
    name: "Warm Cream Flush",
    image: "/pdf-embed/siena-01-hd.jpg",
    description: "Signature cream-painted MDF flush swing door.",
    door_type: "Swing Door",
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
  {
    id: "siena-02", series: "Siena", model_no: "02",
    name: "Black Frosted Glass",
    image: "/pdf-embed/siena-02-hd.jpg",
    description: "Matte-black painted MDF with a frosted glass lite.",
    door_type: "Swing Door",
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
  {
    id: "siena-03", series: "Siena", model_no: "03",
    name: "Pure White Panel",
    image: "/pdf-embed/siena-03-hd.jpg",
    description: "Pure-white MDF with classic recessed panel.",
    door_type: "Swing Door",
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
  {
    id: "siena-04", series: "Siena", model_no: "04",
    name: "Deep Navy Two-Panel",
    image: "/pdf-embed/siena-04-hd.jpg",
    description: "Deep-navy painted MDF with classic two-panel routing.",
    door_type: "Swing Door",
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
  {
    id: "siena-05", series: "Siena", model_no: "05",
    name: "Pure White Line Motif",
    image: "/pdf-embed/siena-05-hd.jpg",
    description: "Pure-white MDF with a modern abstract line motif.",
    door_type: "Swing Door",
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
  {
    id: "siena-06", series: "Siena", model_no: "06",
    name: "Matte Black Pair",
    image: "/pdf-embed/siena-06-hd.jpg",
    description: "Matte-black painted MDF pair — dramatic and architectural swing doors.",
    door_type: "Swing Door",
    swing_only: true,
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },

  // Additional catalog photographs, with descriptive names for unnamed designs.
  // Page 16 is an unlabeled showcase: do not infer a finish family or material.
  {
    id: "atelier-01", series: "Atelier", model_no: "01",
    name: "Walnut with Black Accent",
    image: "/pdf-embed/interior-walnut-black-accent.jpg",
    imageFit: "contain",
    description: "Vertical walnut grain with a black lower accent panel and matching lever.",
    door_type: "Swing Door",
    material: "To be confirmed",
    finish: "To be selected after estimate",
    hardware: "Premium Lever Handle",
  },
  // Painted oval-panel showcase on page 9, following the Siena series.
  {
    id: "siena-07", series: "Siena", model_no: "07",
    name: "Cream Oval Panel",
    image: "/pdf-embed/siena-cream-oval-panel.jpg",
    imageFit: "contain",
    description: "Cream-painted swing door with a rounded top, oval molding and brass-tone lever.",
    door_type: "Swing Door",
    swing_only: true,
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
  // Main Siena photograph and flush/concealed-hinge specifications on page 8.
  {
    id: "siena-08", series: "Siena", model_no: "08",
    name: "Siena Concealed Flush",
    image: "/pdf-embed/siena-concealed-flush.jpg",
    imageFit: "contain",
    description: "Smooth painted MDF with concealed hinges and a clean, wall-integrated profile.",
    door_type: "Swing Door",
    swing_only: true,
    material: "MDF",
    finish: "High-Quality Paint",
    hardware: "Premium Lever Handle",
  },
];

export const INTERIOR_SERIES_ORDER = ["Forma", "Porto", "Siena"];

// -----------------------------------------------------------------------------
// GARAGE DOOR MODELS
// 10 signature garage door designs. Customer only picks size + quantity.
// Colors, finishes and hardware are curated after the estimate is prepared.
// -----------------------------------------------------------------------------
export const GARAGE_MODELS = [
  { id: "denver", model_no: "01", name: "Denver", image: "/pdf-embed/garage-denver.jpg",
    description: "Modern · Cohesive · Built to last. Clean horizontal panels with a signature accent band." },
  { id: "rio", model_no: "02", name: "Rio De Janeiro", image: "/pdf-embed/garage-rio.jpg",
    description: "Modern · Warm · Uncompromising. Warm wood tones with sculpted panel geometry." },
  { id: "denmark", model_no: "03", name: "Denmark", image: "/pdf-embed/garage-denmark.jpg",
    description: "Modern · Timeless · Refined. Bold black frames with frosted glass panels." },
  { id: "montreal", model_no: "04", name: "Montreal", image: "/pdf-embed/garage-montreal.jpg",
    description: "Sleek · Minimal · Sophisticated. Clean vertical lines with a matte finish." },
  { id: "wonderwall", model_no: "05", name: "Wonderwall", image: "/pdf-embed/garage-wonderwall.jpg",
    description: "Bold design · Smooth performance. Vertical plank tilt door with reliable operation." },
  { id: "berlin", model_no: "06", name: "Berlin", image: "/pdf-embed/garage-berlin.jpg",
    description: BERLIN_DESCRIPTION, showFullDescription: true,
    door_type: "Sectional Overhead Door" },
  { id: "monolight", model_no: "07", name: "Monolight", image: "/pdf-embed/garage-monolight.jpg",
    description: "Minimalist · Modern · Unified. Smooth panel surface with subtle horizontal lines." },
  { id: "dark-knight", model_no: "08", name: "Dark Knight", image: "/pdf-embed/garage-dark-knight.jpg",
    description: "Reflective · Modern · Timeless. Reflective glass finish with slim horizontal accents." },
  { id: "aspen", model_no: "09", name: "Aspen", series: "Aspen", image: "/pdf-embed/garage-aspen-mountain.jpg", imageFit: "contain",
    description: "Carriage-style wood-look panels with diagonal bracing and a row of divided windows." },
  { id: "michigan", model_no: "10", name: "Michigan", image: "/pdf-embed/garage-michigan.jpg",
    description: "Timeless simplicity · Modern appeal. Flush panel design with full-width tinted glass." },
];

